module.exports = __webpack_public_path__ + "static/img/RWA664_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWA664_1.png
// module id = uUdg
// module chunks = 0